import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import SiteNavbar from '../components/SiteNavbar';

import FileUpload from '../components/FileUpload';
import MapWithStations from '../components/MapWithStations';
import RailwayExtractor from '../components/RailwayExtractor';
import MatrixViewer from '../components/MatrixViewer';
import ResultsTable from '../components/Results';

import ForkliftPlanner from './planners/ForkliftPlanner';
import RailMountedCranePlanner from './planners/RailMountedCranePlanner';
import AriaPlanner from './planners/ariaPlanner';
import TruckBookingPlanner from './planners/truckBookingPlanner';
import HdvEmissionDss from './planners/hdvEmissionDss';
import BatteryTruckPlanner from './planners/batteryTruckPlanner';
import PortRailScheduling from './planners/portRailScheduling';
import CriticalMineralsDashboard from './planners/criticalMineralsDashboard';

const StandardAppPage = ({ children }) => {
  return (
    <main className="min-h-screen bg-white pt-28 pb-10">
      <Container>
        {children}
      </Container>
    </main>
  );
};

const AppLayout = () => {
  return (
    <div className="min-h-screen bg-black">
      <SiteNavbar />

      <Routes>
        <Route
          path="/"
          element={
            <StandardAppPage>
              <FileUpload />
            </StandardAppPage>
          }
        />

        <Route
          path="/map"
          element={
            <StandardAppPage>
              <MapWithStations />
            </StandardAppPage>
          }
        />

        <Route
          path="/railways"
          element={
            <StandardAppPage>
              <RailwayExtractor />
            </StandardAppPage>
          }
        />

        <Route
          path="/matrix"
          element={
            <StandardAppPage>
              <MatrixViewer />
            </StandardAppPage>
          }
        />

        <Route
          path="/results"
          element={
            <StandardAppPage>
              <ResultsTable />
            </StandardAppPage>
          }
        />

        <Route path="forklift-planner" element={<ForkliftPlanner />} />
        <Route path="rail-mounted-crane-planner" element={<RailMountedCranePlanner />} />
        <Route path="aria-app" element={<AriaPlanner />} />
        <Route path="truck-booking-predictor" element={<TruckBookingPlanner />} />
        <Route path="hdv-emission-dss" element={<HdvEmissionDss />} />
        <Route path="battery-truck-charging" element={<BatteryTruckPlanner />} />
        <Route path="port-rail-scheduling" element={<PortRailScheduling />} />
        <Route path="critical-minerals-dashboard" element={<CriticalMineralsDashboard />} />
      </Routes>
    </div>
  );
};

export default AppLayout;